module.exports = __webpack_public_path__ + "static/media/creativity1.e04e6a03.gif";